import classes from './Result.module.sass'
import done_green from '../../../assets/images/icons/done_green.svg'
import close_red from '../../../assets/images/icons/close_red.svg'

type Props = {
  negative?: boolean
}

export const Result = ({  negative }: Props) => {
  return (
    <div className={negative ? classes.ResultNegative : classes.Result}>
      <img className={classes.Icon} src={negative ? close_red : done_green} alt="Результат" />
    </div>
  )
}
